import React, {FC} from 'react';
import {WebviewContextApi, WebviewProviderProps} from './Webview.context.definition';

export const WebviewProvider: FC<WebviewProviderProps> = ({children}) => <>{children}</>;

export const useWebview = (): WebviewContextApi => ({openLink: () => void 0, close: () => void 0});
